module.exports = __webpack_public_path__ + "img/3.46f73ad3.jpeg";